import { defineComponent as _defineComponent } from 'vue'
import { ObjectType, UpcomingRelease } from '@/@types/graphql-types';

import OfferReporterModal from '@/components/modals/offer-reporter/OfferReporterModal.vue';

import { ModalHelper } from '@/helpers/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferReporter',
  props: {
    titleId: null,
    titleObjectId: null,
    titleObjectType: null,
    titleName: null,
    titleOffers: { default: () => [] },
    additionalContexts: { default: () => [] as SnowplowContext[] }
  },
  setup(__props: any) {

const props = __props as { titleId: string, titleObjectId: number, titleObjectType: ObjectType, titleName: string, titleOffers: TitleOfferFragment[] | UpcomingRelease[], additionalContexts: SnowplowContext[] };



function openModal() {
	ModalHelper.openModal(
		OfferReporterModal,
		{
			titleId: props.titleId,
			titleObjectId: props.titleObjectId,
			titleObjectType: props.titleObjectType,
			titleName: props.titleName,
			titleOffers: props.titleOffers,
		},
		{},
		'',
		false,
		props.additionalContexts
	);
}

return { __sfc: true,props, openModal }
}

})